module.exports = "/packs/course-webdesign-first-f760c8043bccd95fed063189829a2a7b.png";